export default __webpack_public_path__ + "static/media/Beach vibes2.cb7fc4ab.jpg";